import * as actions from "./employee.actions";
import { ActionType, createReducer } from "typesafe-actions";
import { EmployeeReducerType } from "./types";

export type EmployeeActions = ActionType<typeof actions>;

export const initialState: EmployeeReducerType = {
  isLoading: false,
  errorMessage: '',
  listEmployee: [],
};

export const EmployeeReducer = createReducer<
EmployeeReducerType,
  EmployeeActions
>(initialState)
  .handleAction(actions.getEmployeeAsync.request, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getEmployeeAsync.success, (state, action) => ({
    ...state,
    errorMessage: '',
    isLoading: false,
    listEmployee: action.payload.data.items,
  }))
  .handleAction(actions.getEmployeeAsync.failure, (state, action) => ({
    ...state,
    errorMessage: action.payload.message,
    isLoading: false,
  }))
